import BaseApiService from "./BaseApiService";

const messageHandlerApiPath = process.env.REACT_APP_API_HOST
const code = process.env.REACT_APP_API_CODE;

const _taskListing = (topic,id,phone) => {
  if(id)
  {
    return BaseApiService.get(`${messageHandlerApiPath}/api/v1/${topic}?phone=${encodeURIComponent(id)}&code=${code}`, null, false);
  }
  else
  {
    return BaseApiService.get(`${messageHandlerApiPath}/api/v1/${topic}?phone=${encodeURIComponent(phone)}&code=${code}`, null, false);
  }
};

const _taskById = (taskId,topic) => {
    return BaseApiService.get(`${messageHandlerApiPath}/api/v1/${topic}/${taskId}?code=${code}`, null, false);
};

const _taskCreation = (payload,topic) => {
    return BaseApiService.post(`${messageHandlerApiPath}/api/v1/${topic}?code=${code}`, null, payload,false,{});
  };

const _taskEdit = (payload,id,operation,topic) => {
    if(operation === "complete")
    {
        return BaseApiService.put(`${messageHandlerApiPath}/api/v1/${topic}/${id}/complete?code=${code}`, null, payload,false);
    }
    else if(operation === "incomplete"){
        return BaseApiService.put(`${messageHandlerApiPath}/api/v1/${topic}/${id}/incomplete?code=${code}`, null, payload,false);
    }
    else{
        return BaseApiService.patch(`${messageHandlerApiPath}/api/v1/${topic}/${id}?code=${code}`, null, payload,false);
    }

  };

const _taskDelete = (id,topic) => {
  return BaseApiService.delete(`${messageHandlerApiPath}/api/v1/${topic}/${id}?code=${code}`, null,null, false);
};

const _getListLink = (shortCode,phoneNumber) => {
  return BaseApiService.get(`${messageHandlerApiPath}/api/v1/url-shortener/${shortCode}?phone=${encodeURIComponent(phoneNumber)}&code=${code}`, null, false);
};

export const TasksAPIService = {
  taskListing: _taskListing,
  taskById: _taskById,
  taskCreation: _taskCreation,
  taskEdit: _taskEdit,
  taskDelete: _taskDelete,
  getListLink:_getListLink
};
